import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const LEVEL_STYLES = {
  info: { cell: "#e8f1fb", chip: "#1d4ed8" },
  care: { cell: "#ECFDF5", chip: "#065F46" },
  warning: { cell: "#FDF2E2", chip: "#9A6212" },
  critical: { cell: "#FBECEB", chip: "#B23A34" }
};

export default function EmergencyPlanMedicalConsiderationsSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const displayName = section && section.display_name ? section.display_name : "Medical Considerations";
  const considerations = Array.isArray(data.considerations)
    ? data.considerations.filter((consideration) => (
      consideration
      && [consideration.level, consideration.description]
        .some((value) => String(value || "").trim() !== "")
    ))
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <colgroup>
            <col style={{ width: "100px" }} />
            <col />
          </colgroup>
          <tbody>
            {considerations.length > 0 ? considerations.map((consideration, index) => {
              const level = String(consideration.level || "").trim();
              const levelStyle = LEVEL_STYLES[level.toLowerCase()] || LEVEL_STYLES.info;

              return (
                <tr key={consideration.id || index}>
                  <td style={{ width: "20%", background: levelStyle.cell }}>
                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", marginLeft: "5px", padding: "4px 8px", borderRadius: "6px", background: levelStyle.chip, color: "#fff", fontSize: "10px", fontWeight: 700, lineHeight: 1.2 }}>
                      {level || <span>&mdash;</span>}
                    </span>
                  </td>
                  <td>{consideration.description || ""}</td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan={2}>No medical considerations available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
